import { copyShareableUrl, formatCurrency, getQueryParams, updateQueryParams } from '../shared/calculator';
import { isTfsaError } from '../shared/types';
import { calculateTfsaRoom, TFSA_ANNUAL_LIMITS } from './tfsa';

const yearSelect = document.getElementById('year') as HTMLSelectElement;
const ageInput = document.getElementById('age') as HTMLInputElement;
const contribInput = document.getElementById('contributions') as HTMLInputElement;
const residentInput = document.getElementById('resident') as HTMLInputElement;
const errorEl = document.getElementById('error') as HTMLDivElement;
const resultsEl = document.getElementById('results') as HTMLDivElement;
const tableWrap = document.getElementById('table-wrap') as HTMLDivElement;
const tbody = document.querySelector('#breakdown tbody') as HTMLTableSectionElement;

for (const y of Object.keys(TFSA_ANNUAL_LIMITS).map(Number).sort((a, b) => b - a)) {
  const opt = document.createElement('option');
  opt.value = String(y);
  opt.textContent = String(y);
  yearSelect.appendChild(opt);
}

const params = getQueryParams({ year: '2026', age: '30', contributions: '0' });
yearSelect.value = params.year;
ageInput.value = params.age;
contribInput.value = params.contributions;

function render(): void {
  const result = calculateTfsaRoom({
    year: Number(yearSelect.value),
    age: Number(ageInput.value),
    priorContributions: Number(contribInput.value),
    canadianResident: residentInput.checked,
  });

  updateQueryParams({
    year: yearSelect.value,
    age: ageInput.value,
    contributions: contribInput.value,
  });

  if (isTfsaError(result)) {
    errorEl.textContent = result.error;
    errorEl.style.display = 'block';
    resultsEl.style.display = 'none';
    tableWrap.style.display = 'none';
    return;
  }

  errorEl.style.display = 'none';
  resultsEl.style.display = 'block';
  tableWrap.style.display = 'block';

  (document.getElementById('cumulative') as HTMLParagraphElement).textContent =
    formatCurrency(result.cumulativeRoom);
  (document.getElementById('remaining') as HTMLParagraphElement).textContent =
    formatCurrency(result.remainingRoom);
  (document.getElementById('contributed') as HTMLParagraphElement).textContent =
    formatCurrency(result.priorContributions);

  tbody.innerHTML = result.yearlyBreakdown
    .map(
      (row) => `
        <tr class="${row.eligible ? '' : 'ineligible'}">
          <td>${row.year}</td>
          <td>${formatCurrency(row.annualLimit)}</td>
          <td>${row.eligible ? formatCurrency(row.roomAdded) : '—'}</td>
          <td>${row.eligible ? formatCurrency(row.cumulativeRoom) : '—'}</td>
        </tr>
      `,
    )
    .join('');
}

[yearSelect, ageInput, contribInput, residentInput].forEach((el) => {
  el.addEventListener('input', render);
  el.addEventListener('change', render);
});

document.getElementById('share-btn')?.addEventListener('click', () => {
  copyShareableUrl({
    year: yearSelect.value,
    age: ageInput.value,
    contributions: contribInput.value,
  }).then(() => {
    const btn = document.getElementById('share-btn') as HTMLButtonElement;
    btn.textContent = '✅ Copied!';
    setTimeout(() => {
      btn.textContent = '📋 Copy shareable link';
    }, 2000);
  });
});

render();
